<template>
    <vx-widget
        v-bind="$attrs"
        v-on="$listeners"
        title="Request Lookup"
        subtitle="Search and find requests"
        overflow-enabled
        h="3"
        category="orders"
        w="18"
        is-resizable
    >
        <!-- <statement-suggest @input="navigate" remove-validation-padding /> -->
        <vx-elastic-suggest
            name="Request"
            v-model="selectedRequest"
            :showOnFocus="true"
            :search_groups="request_list"
            placeholder="Search for a Request"
        >
            <template v-slot:Requests="{ suggestion }">
                <request-suggest-item :request="suggestion" />
            </template>
        </vx-elastic-suggest>
    </vx-widget>
</template>

<script>
import { mapGetters } from 'vuex'
import RequestSuggestItem from './RequestSuggestItem.vue'
export default {
    name: 'request-lookup-widget',
    components: {
        RequestSuggestItem
    },
    data() {
        return {
            selectedRequest: {},
            request_list: {
                Requests: {
                    searchUrl: '/maarima/Request',
                    idfield: 'id',
                    searchOn: (b) =>
                        `${b.id} ${b.patientFirstName.trim()} ${b.patientLastName.trim()} ${
                            b.practiceName
                        } ${b.costCentreName} 
                        ${b.serviceTaskCount} ${this.status(b)} ${this.urgency(b)}`,
                    displayText: (b) => this.getDisplayText(b)
                }
            }
        }
    },
    watch: {
        selectedRequest: {
            handler: function (newV) {
                this.goToRequest()
                return this.$emit('input', newV.id)
            },
            deep: true
        }
    },
    computed: {
        ...mapGetters({
            getUrgencyById: 'maarima/getUrgencyById',
            getRequestStatusById: 'maarima/getRequestStatusById'
        }),
        isActive() {
            // if (!this.selectedRequest) {
            //     return 'inactive'
            // }
            // if(this.selectedRequest.statusId == 1 || this.selectedRequest.statusId == 2) {
            //     return 'active'
            // }
            return 'active'
        }
    },
    methods: {
        getDisplayText(request) {
            if (request && request.id) {
                return `${request.id}`
            }
            return ''
        },
        goToRequest() {
            if (this.selectedRequest && this.selectedRequest.id) {
                this.$router.push(`/home/requests/${this.isActive}/${this.selectedRequest.id}`)
            }
        },
        status(request) {
            let result = this.getRequestStatusById(request.statusId)
            if (result) {
                return result.name
            }
            return null
        },
        urgency(request) {
            let result = this.getUrgencyById(request.urgencyId)
            if (result) {
                return result.name
            }
            return null
        }
    }
}
</script>

<style scoped lang="scss">
.statement-display:hover {
    cursor: pointer;
}
</style>
